import { Maybe } from '@pylot-data/fwrdschema'

type PropType = {
    isHidden?: Maybe<boolean>
    isAccordion?: Maybe<boolean>
}

const PlusIcon = ({ isHidden = false, isAccordion = false }: PropType) => {
    const strokeColor = isAccordion
        ? '#857149'
        : isHidden
        ? 'transparent'
        : 'black'

    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line
                x1="9.05859"
                y1="0.5"
                x2="9.05859"
                y2="17.5"
                stroke={strokeColor}
            />
            <line
                x1="0.5"
                y1="8.88696"
                x2="17.5"
                y2="8.88696"
                stroke={strokeColor}
            />
        </svg>
    )
}

export default PlusIcon
